const getters = {
  token: state => state.auth.token,
  user: state => state.auth.user,
  catelog: state => state.auth.catelog,
  seachKey: state => state.search.seachKey,
  windowHeight: state => state.window.windowHeight
}
export default getters
